export default {
  INVITE_USER: {
    scope: 'admin',
  },
};
